import React, { useEffect, useCallback, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { useCookies } from 'react-cookie';
import swal from 'sweetalert';


import "./styles.scss";

// ! Components
import Connect from "../../../shared/redux/Connect.hoc";
import ToolBar from "../../../shared/components/ToolBar/ToolBar";

import Login from "../Login/Login.component";
import Signin from "../Signin/Signin.component";
import RecoverPass from "../RecoverPass/RecoverPass.component";
import LoaderSpinner from "../../../shared/components/LoaderSpinner/LoaderSpinner";
import { createNotification } from "../../../utils/utils";

// ? Helpers
// TODO: con "calcularMensajeriaHP" se calcula enviando "valor_declarado" y "distancia"
// TODO: con "newMensajeriaHP" se crea enviando todo hasta "valor_total"
import { calcularMensajeriaHP, newMensajeriaHP, getConfig } from "../../../helpers/Mensajeria.helper"

let map
let infoWindow
let google = window.google
let originPlaceId = null
let destinationPlaceId = null
let latlngOri = null
let latlngD = null
let directionsService = new google.maps.DirectionsService
let directionsRenderer = new google.maps.DirectionsRenderer

function CreateMensajeria({ history, state }) {
  const [showLoading, setShowLoading] = useState(false)
  const [sesion, setSesion] = useState(false)
  const [visibleLogin, setVisibleLogin] = useState(false)
  const [visibleSignin, setVisibleSignin] = useState(false)
  const [visibleForget, setVisibleForget] = useState(false)
  const [alertShow, setAlertShow] = useState(false)
  const [alertShowConfig, setAlertShowConfig] = useState(false)

  const [kilometro, setKilometros] = useState(0)
  const [valorDeclarado, setValorDeclarado] = useState(0)
  const [timeEstimado, setTimeEstimado] = useState(0)
  const [valorMaximo, setValorMaximo] = useState(0)
  const [tiempoGestion, setTiempoGestion] = useState(0)

  const [LatLgnOrigen, setLatLgnOrigen] = useState({})
  const [LatLgnDestino, setLatLgnDestino] = useState({})

  const [alertMessage, setAlertMessage] = useState('')
  const [alertConfig, setAlertConfig] = useState('')

  const [cookies, setCookie, removeCookie] = useCookies(['dataMensajeria']);
  const [cookiesPlaceIdOrigen, setCookiePlaceIdOrigen, removeCookiePlaceIdOrigen] = useCookies(['placeIdOrigen']);
  const [cookiesPlaceIdDestino, setCookiePlaceIdDestino, removeCookiePlaceIdDestino] = useCookies(['placeIdDestino']);


  const formRef = useRef(null)

  useEffect(() => {
    initMaps()
    autoComplete()
    validateSesion()
    validCamposCookies()
    validPlaceRouteByCookies()
    removeCookiePlaceIdDestino('placeIdDestino')
    removeCookiePlaceIdOrigen('placeIdOrigen')
    getConfigs()
  }, []);

  const resetForm = () => {
    removeCookie('dataMensajeria')

    formRef.current[0].value = ''
    formRef.current[1].value = ''
    formRef.current[2].value = ''
    formRef.current[3].value = ''
    formRef.current[4].value = 0
    formRef.current[5].value = 0
    formRef.current[6].value = 0
    formRef.current[7].value = ''


    LatLgnOrigen.lat = ''
    LatLgnOrigen.lng = ''
    LatLgnDestino.lat = ''
    LatLgnDestino.lng = ''
  }


  const validPlaceRouteByCookies = () => {
    if (cookiesPlaceIdOrigen.placeIdOrigen !== undefined && cookiesPlaceIdDestino.placeIdDestino) {
      routerDirection()
    } else {
    }
  }

  const validateSesion = () => {
    if (state.auth.token !== null) {
      setSesion(true);
    }
  }

  const validObjet = (value) => {
    return Object.keys(value).length > 0 ? true : false
  }

  const saveCookies = (data) => {
    setCookie('dataMensajeria', data)
  }

  const validCamposCookies = () => {
    if (validObjet(cookies) && cookies.dataMensajeria !== undefined && cookies.dataMensajeria) {
      //debugger
      formRef.current[0].value = cookies.dataMensajeria.origen.direccion
      formRef.current[1].value = cookies.dataMensajeria.destino.direccion
      formRef.current[2].value = cookies.dataMensajeria.valor_declarado
      formRef.current[3].value = cookies.dataMensajeria.paquete
      formRef.current[6].value = cookies.dataMensajeria.observaciones
      LatLgnOrigen.lat = cookies.dataMensajeria.origen.lat
      LatLgnOrigen.lng = cookies.dataMensajeria.origen.lng
      LatLgnDestino.lat = cookies.dataMensajeria.destino.lat
      LatLgnDestino.lng = cookies.dataMensajeria.destino.lng
    } else {
      removeCookie('dataMensajeria')
    }
  }

  const showAlert = (message) => {
    setAlertShow(true)
    setAlertMessage(message)

    setTimeout(() => {
      setAlertShow(false)
    }, 3000)
  }
  const showAlertConfig = (message) => {
    setAlertShowConfig(true)
    setAlertConfig(message)

    setTimeout(() => {
      setAlertShowConfig(false)
    }, 3000)
  }

  const handleRequest = useCallback(async (event) => {
    console.log("--Mensajeria.handleRequest--")
    event.preventDefault()
    if (!state.auth.token) {
      createNotification("Debes iniciar sesión primero", "warn");
      return
    }
    setShowLoading(true)

    const {
      origen,
      destino,
      valordeclarado,
      tipopaquete,
      observaciones,
      valor
    } = event.target.elements
    //debugger
    const body = {
      cliente: state.auth.user._id,
      origen: {
        direccion: origen.value,
        lat: (LatLgnOrigen.lat !== undefined) ? LatLgnOrigen.lat : '',
        lng: (LatLgnOrigen.lng !== undefined) ? LatLgnOrigen.lng : '',
      },
      destino: {
        direccion: destino.value,
        lat: (LatLgnDestino.lat !== undefined) ? LatLgnDestino.lat : '',
        lng: (LatLgnDestino.lng !== undefined) ? LatLgnDestino.lng : '',
      },
      valor_declarado: valordeclarado.value,
      valor_total: valor.value,
      paquete: tipopaquete.value,
      observaciones: observaciones.value,
      distancia: kilometro
    }
    // guardamos en cookies
    saveCookies(body)
    let flag = true
    if (flag) {
      //body.cliente = state.auth.user._id

      if (body.origen.direccion === '') {
        showAlert('Por favor ingrese un punto de origen')
        return
      } else if (body.destino.direccion === '') {
        showAlert('Por favor ingrese un punto de destino')
        return
      } else if (body.valor_declarado === '') {
        showAlert('Digite un valor declarado')
        return
      } else if (body.paquete === '') {
        showAlert('Digite el tipo de paquete a selecionar')
        return
      }
      try {
        const response = await newMensajeriaHP(body)
        if (response['code'] === 400) {
          swal({
            title: "Problemas generando Servicio",
            text: response["message"],
            icon: "error",
            buttons: true,
          })
          // createNotification("Ha ocurrido un problema al crear el serivicio, inténtalo nuevamente", "error");
        } else {
          removeCookie('dataMensajeria')
          resetForm()
          swal({
            title: "Servicio Generado",
            icon: "success",
            button: "Ver",
            showCancelButton: true,
          })
          .then(e => {
            history.push('/mismensajerias')


          })
          // createNotification("Servicio de mensajería creado con éxito!!!", "success");
        }
        setShowLoading(false);
      } catch (error) {
        console.error(
          "--CreateMensajeria.Component.handleRequest-- error: ",
          error
        )
        setShowLoading(false);
      }

      console.log(body, 'body')
    } else {
      createNotification("No has iniciado sesión!!!", "warn")
      setShowLoading(false)
      setVisibleLogin(true)
    }
  }, [kilometro, LatLgnOrigen, LatLgnDestino, cookies.dataMensajeria])

  const onCloseLogin = () => {
    console.log("CreateMensajeria.Componente.onCloseSignin");
    setVisibleLogin(false);
  };
  const onCloseSignin = () => {
    console.log("CreateMensajeria.Componente.onCloseSignin");
    setVisibleSignin(false);
  };

  const onCloseForget = () => {
    console.log("CreateMensajeria.Componente.onCloseForget");
    setVisibleForget(false);
  };

  const onOpenSignin = () => {
    console.log("CreateMensajeria.Componente.onCloseSignin");
    setVisibleLogin(false);
    setVisibleSignin(true);
  };

  const onOpenForgotePass = () => {
    console.log("CreateMensajeria.Componente.onOpenForgotePass");
    setVisibleLogin(false);
    setVisibleForget(true);
  };

  const onRecover = () => {
    console.log("CreateMensajeria.Componente.onRecover");
    onCloseForget();
  };

  const onSignin = () => {
    console.log("CreateMensajeria.Componente.onSignin");
    onCloseSignin();
  };

  const toolBarLogin = () => {
    console.log(" --CreateMensajeria.Componente.toolBarLogin--  ");
    setVisibleLogin(true);
    setVisibleForget(false);
    setVisibleSignin(false);
  };

  const toolBarSignin = () => {
    console.log(" --CreateMensajeria.Componente.toolBarLogin--  ");
    setVisibleLogin(false);
    setVisibleForget(false);
    setVisibleSignin(true);
  };


  // function del map
  const initMaps = () => {
    map = new google.maps.Map(document.getElementById('map'), {
      zoom: 10,
      streetViewControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP    // Set Map Type Here ROADMAP, TERRAIN, SATELLITE
    })
    infoWindow = new google.maps.InfoWindow
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }

        infoWindow.setPosition(pos)
        //infoWindow.setContent('Location found.')
        //infoWindow.open(map)
        map.setCenter(pos)
        autoComplete(map)
      }, () => {
        handleLocationError(true, infoWindow, map.getCenter())
      })
    } else {
      // Browser doesn't support Geolocation
      handleLocationError(false, infoWindow, map.getCenter())
    }
  }

  const handleLocationError = (browserHasGeolocation, infoWindow, pos) => {
    infoWindow.setPosition(pos)
    infoWindow.setContent(browserHasGeolocation ?
      'Error: The Geolocation service failed.' :
      'Error: Your browser doesn\'t support geolocation.');
    infoWindow.open(map)
  }



  const autoComplete = () => {
    console.log(" --CreateMensajeria.Componente.autoComplete--  ");

    let origen = document.getElementById('origen')
    let destino = document.getElementById('destino')

    google.maps.event.addDomListener(origen, 'keydown', function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });

    google.maps.event.addDomListener(destino, 'keydown', function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });

    let options = {
      componentRestrictions: { country: 'CO' }
    }
    let autoCompleteOrigin = new google.maps.places.Autocomplete(origen, options)
    autoCompleteOrigin.bindTo('bounds', map)
    autoCompleteOrigin.setFields(['address_components'])

    let autoCompleteDestino = new google.maps.places.Autocomplete(destino, options)
    autoCompleteDestino.bindTo('bounds', map)
    autoCompleteDestino.setFields(['address_components', 'geometry', 'name', 'place_id'])

    setupPlaceChangedListener(autoCompleteOrigin, 'ORIGIN')
    setupPlaceChangedListener(autoCompleteDestino, 'DESTINY')
  }

  const setupPlaceChangedListener = (autoComplete, mode) => {
    let latLngO = {}
    let latLngDes = {}
    autoComplete.addListener('place_changed', () => {

      let place = autoComplete.getPlace()
      if (!place.place_id) {
        console.log('por favor seleccione una opcion de la lista que se muestra')
      }

      if (mode === 'ORIGIN') {
        removeCookiePlaceIdOrigen('placeIdOrigen')
        latLngO = {
          lat: place.geometry && place.geometry.location.lat(),
          lng: place.geometry && place.geometry.location.lng()
        }
        latlngOri = latLngO
        setLatLgnOrigen(latLngO)
        setCookiePlaceIdOrigen('placeIdOrigen', place.place_id)
        originPlaceId = place.place_id
      } else if (mode === 'DESTINY') {
        removeCookiePlaceIdDestino('placeIdDestino')
        latLngDes = {
          lat: place.geometry && place.geometry.location.lat(),
          lng: place.geometry && place.geometry.location.lng()
        }
        latlngD = latLngDes
        setLatLgnDestino(latLngDes)
        setCookiePlaceIdDestino('placeIdDestino', place.place_id)
        destinationPlaceId = place.place_id
      }
      routerDirection()
    })
  }

  const routerDirection = () => {
    console.log("--CreateMensajeria.routerDirection--")
    if (originPlaceId !== null && destinationPlaceId !== null || cookiesPlaceIdOrigen.placeIdOrigen !== undefined && cookiesPlaceIdDestino.placeIdDestino !== undefined) {
      directionsService.route({
        origin: { 'placeId': (cookiesPlaceIdOrigen.placeIdOrigen !== undefined) ? cookiesPlaceIdOrigen.placeIdOrigen : originPlaceId },
        destination: { 'placeId': (cookiesPlaceIdDestino.placeIdDestino !== undefined) ? cookiesPlaceIdDestino.placeIdDestino : destinationPlaceId },
        travelMode: 'DRIVING',
        transitOptions: {
          routingPreference: 'FEWER_TRANSFERS'
        },
        optimizeWaypoints: true,
        avoidTolls: true,
        provideRouteAlternatives: false,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
        avoidFerries: true,
        avoidTolls: true,
        avoidHighways: true
      }, (response, status) => {
        if (status === 'OK') {
          directionsRenderer.setDirections(response)
          directionsRenderer.setMap(map)
          calcuDistance()
        } else {
          console.log('Directions request failed due to')
        }
      })

    } else {
      removeCookiePlaceIdDestino('placeIdDestino')
      removeCookiePlaceIdOrigen('laceIdOrigen')
    }
  }
  const calcuDistance = async () => {
    const origin = new google.maps.LatLng(latlngOri)
    const destino = new google.maps.LatLng(latlngD)
    const service = new google.maps.DistanceMatrixService()
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destino],
        travelMode: 'DRIVING',
        avoidHighways: true,
        avoidTolls: true,
      }, callback)
  }

  const callback = (response, status) => {
    let jsonObjec = {}
    if (status === 'OK' && Array.isArray(response['rows'])) {
      Promise.all(
        response['rows'].map(item => {
          if (Array.isArray(item['elements'])) {
            item['elements'].map(item2 => {
              if (item2['status'] === 'OK') {
                jsonObjec = {
                  distance: item2['distance'],
                  duration: item2['duration']
                }
              }
            })
          }
        })
      )
      let time = parseInt(jsonObjec['duration'] !== undefined ? jsonObjec['duration']['text'] : '')
      let timeEstimado = (time + tiempoGestion)
      setTimeEstimado(timeEstimado)
      let num = parseInt(jsonObjec.distance !== undefined ? jsonObjec.distance['text'] : '')
      setKilometros(Math.ceil(num))
      return jsonObjec
    }
  }

  const onChangeValor = async (e) => {
    const valor = parseInt(e.target.value = e.target.value.replace(/[^0-9]/g, '').substring(0, 6))
    if (kilometro === 0) {
      showAlert('No hay una distancia aceptable')
    }

    if (valor !== '' && valor !== 0 && kilometro !== 0) {

      try {
        const data = {
          valor_declarado: valor,
          distancia: kilometro
        }
        const calcularApi = await calcularMensajeriaHP(data)
        if (calcularApi['code'] === 200) {
          setValorDeclarado(calcularApi['data'])
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  const getConfigs = async () => {
    try {
      const config = await getConfig()
      if (config['code'] === 200 && config['data'].length > 0) {
        setValorMaximo(config['data'][0]['valor_maximo'])
        setTiempoGestion(config['data'][0]['tiempo_gestion'])
        return config['data']
      }
    } catch (error) {
      throw error
    }

  }

  const onKeyup = ($event) => {
    if ($event.detail === 0) {
      showAlertConfig(`Por favor digita el valor de la mercancía hasta un máximo ${valorMaximo.toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 })}`)
    }

  }



  return (
    <div className= "container-mensajeria" >
     
      {showLoading &&
        <LoaderSpinner show={showLoading} />
      }
      <div className="longitud">
        <div className="row">
          <div className="col-6 firstCol">
            <div className="container content">
              <form onSubmit={handleRequest}  id="my-form" ref={formRef} >
                <div className="form-group">
                  <input type="text" name="origen" style = {{borderRadius: '15px' }} placeholder='Dirección de origen' className="form-control input-message" id="origen" required />
                </div>

                <div className="form-group">
                  <input type="text" name="destino"  style = {{borderRadius: '15px' }} placeholder='Dirección de destino' className="input-message form-control" id="destino" required />
                </div>
                <div className="form-row" >
                  <div className="form-group col-md-4">
                    <input type="text"  style = {{borderRadius: '15px' }} name="valordeclarado" placeholder='Valor Declarado $' className="form-control input-message" id="valordeclarado" onChange={onChangeValor} onKeyUp={onKeyup} required />
                    {alertShowConfig &&
                      <small style={{ color: '#FF2D00' }}> {alertConfig}  </small>
                    }
                  </div>


                  <div className="form-group col-md-8">
                    
                    <select id="msj-tipopaqueteInput" name="tipopaquete" className="form-control input-message" style = {{borderRadius: '15px' }}>
                      <option disabled hidden selected value="">Tipo de paquete</option>
                      <option value="Documentos">Documentos (sobre o carta)</option>
                      <option value="Maleta">Maleta (40x38x38 cm)</option>
                      <option value="Baúl">Baúl (30x30x30 cm)</option>
                      <option value="Parrilla">Parrilla (50x50x350 cm)</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-md-4">
                    <label htmlFor="distancia" className = 'label-message'>Distancia</label>
                    <input type="text" name="distancia" style = {{borderRadius: '15px' }} className="form-control text-center input-message" id="distancia" placeholder='0 km' value={(cookies.dataMensajeria !== undefined) ? cookies.dataMensajeria.distancia : kilometro + ' km'} disabled />
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="valor" className = 'label-message'>Valor</label>
                    <input type="text" name="valor" style = {{borderRadius: '15px' }} className="form-control text-center input-message" id="valor" placeholder='$0' value={(cookies.dataMensajeria !== undefined) ? cookies.dataMensajeria.valor_total : valorDeclarado} disabled />
                  </div>
                  <div className="form-group col-md-4">
                  <label htmlFor="valor" className = 'label-message'>Tiempo estimado</label>
                    <input type="text" style = {{borderRadius: '15px' }} name="timeEstimado" className="form-control text-center input-message" id="timeEstimado" placeholder='0' value={timeEstimado} disabled />
                  </div>
                </div>

                <div className="form-group">
                  <textarea className="form-control" id="observaciones" rows="3" name="observaciones"></textarea>
                </div>

                <div className="form-group">
                  {alertShow &&
                    <div className="alert alert-danger" role="alert">
                      {alertMessage}
                    </div>
                  }
                </div>
                
              </form>
            </div>
          </div>
          <div className="col-5">
            <div id="map" className="map"></div>
          </div>
          <div className='col'>
          <button type="submit"  form="my-form" className="btn-message ">
                  CONFIRMAR SERVICIO
                </button>
          </div>
          
        </div>
      </div>

    </div>



  );
}

export default withRouter(Connect(CreateMensajeria));
